import { BaseLayout } from 'aem-libs-react-components/src/components/calculators/layouts/base-layout'
import { Content } from 'aem-libs-react-components/src/components/common/content'
import { QueryProvider } from 'aem-libs-react-components/src/components/utility/query-provider/QueryProvider'

import { InputFields } from './components/InputFields'
import { ResultBoard } from './components/ResultBoard'

export const App = () => {
  return (
    <QueryProvider>
      <Content contentWidth={'medium'}>
        <BaseLayout inputComponent={<InputFields />} resultComponent={<ResultBoard />} />
      </Content>
    </QueryProvider>
  )
}
